import LAYOUT_CONST from 'constant';

// types
import { ConfigProps } from 'types/config.types';

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

// default page where every home button is redirecting.
export const MAINPAGE_PATH = '/dashboard';

const config: ConfigProps = {
    layout: LAYOUT_CONST.HORIZONTAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 6,
    outlinedFilled: true,
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    rtlLayout: false,
    container: false,
    notificationsPollingInterval: 30000
};

export default config;
